import { ADMIN, FULLADMIN } from '../../../constants/roles';
import { useGlobalContext } from '../../context';
import clsx from 'clsx';
import React from 'react';
import useStyles from './VersionField.styles';

interface FieldProps {
  placeholder?: string;
  changeInputVersion: (version: string) => void;
  size?: 'medium';
  errorInputFormat?: boolean;
  handleBlur: (event: {
    target: { validity: { patternMismatch: boolean } };
  }) => void;
  inputMask?: string;
}

export const VersionField: React.FC<FieldProps> = ({
  placeholder = '__.__.__.__',
  changeInputVersion,
  size = 'medium',
  errorInputFormat,
  handleBlur,
  inputMask = '^(\\d{1,3}\\.){3}(\\d{1,3})$',
}) => {
  const classes = useStyles();
  const { userdata } = useGlobalContext();

  return (
    <div className={classes.root}>
      {(userdata.roles.includes(ADMIN) ||
        userdata.roles.includes(FULLADMIN)) && (
        <input
          className={clsx(classes.field, classes[size])}
          data-qa-name="version_field"
          placeholder={placeholder}
          type="search"
          pattern={inputMask}
          data-politespace
          onBlur={handleBlur}
          onChange={event => changeInputVersion(event.target.value)}
        />
      )}
      {errorInputFormat && (
        <p role="alert" className={classes.alert} data-qa-name="version_alert">
          Please enter a correct version
        </p>
      )}
    </div>
  );
};
